import React, { ReactNode, useState } from 'react';
import '../styles.css';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';

const Drawer = (props: { title: string, children: ReactNode }) => {
    const [isOpen, setIsOpen] = useState(false);
  
    const toggleDrawer = () => {
      setIsOpen(!isOpen);
    };
  
    return (
      <div className="drawer-container">
        <div onClick={toggleDrawer} className="drawer-title">
          {props.title}
          {isOpen ? <FaCaretUp/> : <FaCaretDown/>}
        </div>
        <div className={`drawer-content ${isOpen ? 'open' : ''}`}>
          {props.children}
        </div>
      </div>
    );
  };
  
  export default Drawer;